import { useEffect, useState } from "react";
import { FAQ } from "../../components";
import { FAQLoader } from "../../components/loaders/productLoaders";
import cmsBlockService from "../../services/cmsBlockService";
import { useAppDispatch, useAppSelector } from "../../hooks";
import { selectContactUsSelector } from "../../store/cmsBlock/selector";
import { selectFaqSelector } from "../../store/faq/selector";
import { cmsBlockActionDispatch } from "../../store/cmsBlock/actions";
import { faqActionDispatch } from "../../store/faq/actions";
import faqService from "../../services/faqService";
import { cmsBlockKeys } from "../../utils/constants";

const FAQLayout = () => {
  const [loading, setLoading] = useState({ contactus: true, faq: true });

  const { setContactUs } = cmsBlockActionDispatch(useAppDispatch());
  const { setFaq } = faqActionDispatch(useAppDispatch());

  const faqData = useAppSelector(selectFaqSelector);
  const contactUsCMSBlock = useAppSelector(selectContactUsSelector);

  const fetchData = async () => {
    let temploading = { ...loading };
    await cmsBlockService.setCMSBlocks(
      cmsBlockKeys.contactUs,
      setContactUs,
      () => {
        temploading.contactus = false;
        setLoading(temploading);
      }
    );
    await faqService.setFaq(setFaq, () => {
      temploading.faq = false;
      setLoading(temploading);
    });
  };

  useEffect(() => {
    fetchData();
  }, []);

  return !(loading.contactus && loading.faq) ? (
    <FAQ data={faqData} contactUs={contactUsCMSBlock} />
  ) : (
    <FAQLoader />
  );
};

export default FAQLayout;
